export const styles = {
	rectangle: {
		width: '225px',
		border: '1px solid #0000003B',
		borderRadius: '4px',
		justifyContent: 'center',
		alignItems: 'center',
		margin: '8px',
		flex: 1,
		'@media (max-width: 1000px)': {
			width: '100%',
			flex: 1,
		},
	},
	rectangleWithSubject: {
		width: '225px',
		border: '1px solid #0000003B',
		borderRadius: '4px',
		margin: '8px',
		flex: 1,
		minHeight: '80px',
		flexDirection: 'column',
		position: 'relative',
		borderBottom: '1px solid #0000003B',
		'@media (max-width: 1250px)': {
			width: '100%',
			flex: 1,
		},
	},
	subjectArea: {
		width: '100%',
		backgroundColor: '#FFDDE7',
		borderRadius: '3px 3px 0 0',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderBottom: '1px solid #0000003B',
		paddingBottom: '5px',
		paddingTop: '5px',
		position: 'relative',
	},
	contentArea: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '4px 8px',
		boxSizing: 'border-box',
	},
	subjectText: {
		fontSize: '12px',
		textAlign: 'center',
	},
	container: {
		alignItems: 'center',
	},
	circularProgressIcon: {
		color: 'secondary.main',
	},
	loadingText: {
		paddingLeft: '10px',
	},
	text: {
		padding: '10px',
		textAlign: 'center',
	},
}
